import { Action } from '@ngrx/store';

export enum ActionTypes {
  FETCH_ADDITIONAL_SERVICE = '[Location Specification] Fetch Additional Services',
  ADD_ADDITIONAL_SERVICE = '[Location Specification] Add Additional Services',
  CLEAR_ADDITIONAL_SERVICE = '[Location Specification] Clear Additional Services',
  NO_ACTION = '[Location Specification] No Action',
}

export class AddAdditionalServices implements Action {
  readonly type = ActionTypes.ADD_ADDITIONAL_SERVICE;
  constructor(public payload: { additionalServices: any[] }) {}
}

export class ClearAdditionalServices implements Action {
  readonly type = ActionTypes.CLEAR_ADDITIONAL_SERVICE;
  constructor() {}
}

export class NoAction implements Action {
  readonly type = ActionTypes.NO_ACTION;
  constructor() {}
}

export type Actions = AddAdditionalServices | ClearAdditionalServices | NoAction;
